import {
    createStyles,
    Theme,
    Typography,
    withStyles,
    WithStyles,
    Zoom
} from "@material-ui/core";
import "moment-timezone";
import * as React from "react";
import Moment from "react-moment";
import { IParcelBid } from "../../../models/parcel/IParcelBid";
import Constants from "../../../models/utility/Constants";
import { Numbers } from "../../../models/utility/Numbers";
import * as ParcelBidNodeCss from "../../../styles/ParcelBidNodeCss";

type IProps = WithStyles<typeof styles | typeof ParcelBidNodeCss.styles> & {
    bid: IParcelBid;
    bidPosition: "start" | "middle" | "end";
    isCurrentUser: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        bidTimeWrapper: { whiteSpace: "nowrap" },
        circleBid: {
            [theme.breakpoints.down("xs")]: {
                height: 17,
                width: 17
            },
            backgroundColor: "#C0C0C0",
            borderRadius: "50%",
            height: 20,
            position: "relative",
            width: 20
        },
        circleBidUser: {
            [theme.breakpoints.down("xs")]: {
                height: 30,
                width: 30
            },
            backgroundColor: theme.palette.success.light,
            borderRadius: "50%",
            height: 35,
            position: "relative",
            width: 35
        },
        ...ParcelBidNodeCss.styles(theme)
    });

class ParcelBidHistoryNode extends React.PureComponent<IProps, {}> {
    public render() {
        const { bid, bidPosition, classes, isCurrentUser } = this.props;

        const bidClassCircle = isCurrentUser
            ? classes.circleBidUser
            : classes.circleBid;
        const bidClassText = isCurrentUser
            ? classes.textBidUser
            : classes.textBid;
        const textClasses = `${classes.textBase} ${bidClassText}`;

        return (
            <Zoom in={true}>
                <div className={classes.bidNodeWrapper}>
                    {this.renderTimeLine(bidPosition)}

                    <div className={classes.bidBlockTop}>
                        {isCurrentUser && (
                            <Typography
                                className={`${textClasses} ${classes.textTop}`}
                                component="div"
                                variant="button"
                            >
                                Your Bid
                            </Typography>
                        )}
                    </div>
                    <div className={classes.bidBlockMiddle}>
                        <div className={bidClassCircle} />
                    </div>
                    <div className={classes.bidBlockBottom}>
                        <div className={classes.bidTimeWrapper}>
                            <Typography
                                className={`${classes.textTime} ${textClasses}`}
                                component="span"
                                variant="button"
                                display="inline"
                            >
                                {
                                    <Moment
                                        date={bid.bidReceivedTime}
                                        format={
                                            Constants.TimeFormatNoZoneNoAmPm
                                        }
                                        tz={Constants.TimeZone}
                                    />
                                }
                            </Typography>
                            <Typography
                                className={`${classes.textBidAmount} ${textClasses}`}
                                component="span"
                                variant="caption"
                                display="inline"
                            >
                                {
                                    <Moment
                                        date={bid.bidReceivedTime}
                                        format={Constants.TimeFormatAmPmOnly}
                                        tz={Constants.TimeZone}
                                    />
                                }
                            </Typography>
                        </div>

                        <Typography
                            className={`${classes.textBidAmount} ${textClasses}`}
                            component="div"
                            variant="caption"
                        >
                            {Numbers.toShortFormat(bid.bidAmount)}
                        </Typography>
                    </div>
                </div>
            </Zoom>
        );
    }

    private renderTimeLine = (position: "start" | "middle" | "end") => {
        const classes = this.props.classes;

        let wrapperClasses = classes.timeline;
        let lineClasses = classes.timelineTopLine;

        if (position === "start") {
            wrapperClasses += ` ${classes.timelineStart}`;
            lineClasses += ` ${classes.timelineStartOrEndLine} ${classes.timelineStartLine}`;
        } else if (position === "end") {
            wrapperClasses += ` ${classes.timelineEnd}`;
            lineClasses += ` ${classes.timelineStartOrEndLine} ${classes.timelineEndLine}`;
        }

        return (
            <div className={wrapperClasses}>
                <div className={lineClasses} />
            </div>
        );
    };
}

export default withStyles(styles)(ParcelBidHistoryNode);
